import { createFileRoute } from '@tanstack/react-router'

import { EvaluationsPage } from '#/modules/ai/back-office/evaluations-page/evaluations-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/ai/evaluations/')({
  beforeLoad: (options) => requirePermissions(options, ['aiAnalysis.review.read']),
  component: function Component() {
    return <EvaluationsPage />
  },
})
